import { useDispatch as useOriginalDispatch } from 'react-redux';
import { Dispatch } from '../../../index';

export const useDispatch = () => {
  const dispatch: Dispatch = useOriginalDispatch();
  return dispatch;
};

export default useDispatch;
